import { ActionManager } from '@sas/nova-core/actionManager';
import { useEffect } from 'react';
import { ContextMenuButtonProps } from '.';

export const useActionManager = (
  actionManager: ActionManager,
  actionHistoryChangedHandler: () => void
) => {
  useEffect(() => {
    actionManager.addEventListener('actionHistoryChanged', actionHistoryChangedHandler);
    return () => {
      actionManager.removeEventListener('actionHistoryChanged', actionHistoryChangedHandler);
    };
  }, [actionHistoryChangedHandler, actionManager]);
};

export const useActionManagers = (
  actionManagers: ReadonlyArray<ActionManager>,
  actionHistoryChangedHandler: () => void
) => {
  useEffect(() => {
    for (const actionManager of actionManagers) {
      actionManager.addEventListener('actionHistoryChanged', actionHistoryChangedHandler);
    }
    return () => {
      for (const actionManager of actionManagers) {
        actionManager.removeEventListener('actionHistoryChanged', actionHistoryChangedHandler);
      }
    };
  }, [actionHistoryChangedHandler, actionManagers]);
};

export const getUndoRedoProps = (actionManager: ActionManager) => {
  return {
    undoProps: getUndoOrRedoProps(actionManager, 'undo'),
    redoProps: getUndoOrRedoProps(actionManager, 'redo'),
  };
};

const getUndoOrRedoProps = (
  actionManager: ActionManager,
  type: 'undo' | 'redo'
): Pick<ContextMenuButtonProps, 'sections' | 'onPress' | 'onItemSelected' | 'disabled'> => {
  const actions = [
    ...(type === 'undo' ? actionManager.getUndoActions() : actionManager.getRedoActions()),
  ].reverse();

  return {
    sections: [
      {
        items: actions.map((action) => ({
          text: action.getDisplayString(),
        })),
      },
    ],
    disabled: actions.length === 0,
    onPress: type === 'undo' ? () => actionManager.undoAction() : () => actionManager.redoAction(),
    onItemSelected:
      type === 'undo'
        ? ([[_sectionIndex, itemIndex]]) => actionManager.undoActionHistoryTo(actions[itemIndex])
        : ([[_sectionIndex, itemIndex]]) => actionManager.redoActionHistoryTo(actions[itemIndex]),
  };
};
